import type {TicketChannel} from '../types/ticket';

/**
 * How a ticket's arrival channel reads to an agent. Named once so the detail
 * header, the Details panel and any filter can never disagree, and so the raw
 * enum value (`customer_portal`) never reaches the page.
 */
export const CHANNEL_LABELS: Record<TicketChannel, string> = {
	manual: 'Manual',
	email: 'Email',
	phone: 'Phone',
	chat: 'Chat',
	internal: 'Internal',
	api: 'API',
	customer_portal: 'Customer portal',
};

/**
 * The design system glyph for a channel, where one fits. Email is the only channel
 * with an unambiguous glyph in the set, and it is also the one that matters — an
 * emailed ticket has a customer waiting on a reply. The rest read as text alone
 * rather than borrowing a glyph that means something else.
 */
export const CHANNEL_ICONS: Partial<Record<TicketChannel, string>> = {
	email: 'mail',
};
